module.exports = __webpack_public_path__ + "img/close.53b4967c.svg";